
import { createAPI, deleteAPI, getByBodyAPI, getByIdAPI, updateAPI } from "../../../redux/crudSlice"
import { AppDispatch, store } from "../../../store/store"
import { MenuGroupKeys } from "./entity"
import { createMenuGroupAPI, deleteMenuGroupAPI, menuGroupGetByIdAPI, menuGroupPagingAPI, updateMenuGroupAPI } from "../../../api/url"
import { APICallFunction } from "../role/apiCall"
import { getLocalStorageItem } from "../../../utils/storageHelper"
const { dispatch } = store


export const getMenuGroupPaging = async (dispatch: AppDispatch, _request: Object) => {

    const res = await dispatch(getByBodyAPI({
        key: MenuGroupKeys.paging,
        url: menuGroupPagingAPI,
        request: {
            ..._request,
            ApplicationId: getLocalStorageItem('ApplicationId')
        },
    }));
    return res?.payload?.value
}

export const deleteMenuGroup = async (dispatch: AppDispatch, _request: Object) => {
    const res = await dispatch(deleteAPI({
        key: MenuGroupKeys.delete,
        url: deleteMenuGroupAPI(_request),
        request: { MenuGroupId: _request, IsActive: false, IsDeleted: true }
    }));
    return res?.payload?.value
}

export const getMenuGroupbyId: APICallFunction = async (params) => {
    const { key = MenuGroupKeys.get, request = {}, url = menuGroupGetByIdAPI(request?.id) } = params;
    const res = await dispatch(getByIdAPI({ key: key, url: url, params: request }));
    return res?.payload?.value;
}

export const createMenuGroup: APICallFunction = async (params) => {
    const { key = MenuGroupKeys.create, request = {}, url = createMenuGroupAPI } = params;
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const updateMenuGroup: APICallFunction = async (params) => {
    const { key = MenuGroupKeys.update, request = {}, url = updateMenuGroupAPI(request.id) } = params;
    const res = await dispatch(updateAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}
